import { ContentButton as Button } from '../content/button';
import { ContentIntro as Intro } from '../content/intro';

/**
 * Model definition for pension-calculator
 */

export interface FormsPensionCalculator {
  __component: 'forms.pension-calculator';
  id: string;
  intro?: Intro;
  cta?: Button;
  yearOfBirth: number;
  salary: number;
  children: number;
  professionStartAge: number;
  absenteeism: number;
  professionalGroup: boolean;
}

export function isFormsPensionCalculator(obj: { __component?: string }): obj is FormsPensionCalculator {
  return obj.__component === 'forms.pension-calculator';
}
